export enum WaitOnSendEvaluation {
    Not_Started = 0,
    PreTrigger = 1,
    Started = 2,
    Completed = 3,
    Failed = 4
}

export enum WaitOnSendFailureReason {
    Not_Available = 0,
    User_Initiated_SendAnyway = 1,
    User_Initiated_CancelSend = 2,
    Augloop_Runtime_Issue = 3
}

export interface DLPWaitOnSendViewState {
    waitOnSendEvaluation: WaitOnSendEvaluation;
    waitOnSendTimeElapsed: number;
    waitOnSendFailureReason: WaitOnSendFailureReason;
    isEvaluationDelayed: boolean;
    isWaitOnSendTimeout: boolean;
    isSendAnywayAllowed: boolean;
    resolveConclusiveAnnotation?: () => void;
    rejectConclusiveAnnotation?: (error: Error) => void;
}
